import { InjectionToken } from '@angular/core';

export interface LogSettings {
  interval: number;
}

export const LOG_SETTINGS = new InjectionToken('logService.LOG_SETTINGS');
